import { Product } from '../../models/Product';
import ProductPrice from '../product/ProductPrice';
import ProductMiniature from '../product/miniature/ProductMiniature';
import { useTranslation } from '../../hooks/useTranslation';
import './ProductAddedToCartMessage.less';

export type ProductAddedToCartMessageProps = {
    product: Product;
};

const ProductAddedToCartMessage = ({
    product
}: ProductAddedToCartMessageProps) => {
    const { t } = useTranslation();
    return (
        <div className={`bri-ProductAddedToCartMessage`}>
            <ProductMiniature size="medium" aspectRatio="1" product={product} />
            <div className={`bri-ProductAddedToCartMessage-text`}>
                <div
                    className={`bri-ProductAddedToCartMessage-title bri-DisplayBoldFont`}
                >
                    {t('ADDED_TO_CART_ONE')}
                </div>
                <div
                    className={`bri-ProductAddedToCartMessage-name bri-BodyFont`}
                >
                    {product.name}
                </div>
                <div
                    className={`bri-ProductAddedToCartMessage-price bri-DisplayBoldFont`}
                >
                    <ProductPrice product={product} />
                </div>
            </div>
            <svg
                className={`bri-ProductAddedToCartMessage-icon`}
                xmlns="http://www.w3.org/2000/svg"
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
            >
                <circle
                    cx="15.5"
                    cy="15.832"
                    r="13.5"
                    fill="white"
                    stroke="white"
                    stroke-width="3"
                />
                <path
                    d="M15.5 5.83203C21.0228 5.83203 25.5 10.3092 25.5 15.832C25.5 21.3549 21.0228 25.832 15.5 25.832C9.97715 25.832 5.5 21.3549 5.5 15.832C5.5 10.3092 9.97715 5.83203 15.5 5.83203ZM15.5 7.08203C10.6675 7.08203 6.75 10.9995 6.75 15.832C6.75 20.6645 10.6675 24.582 15.5 24.582C20.3325 24.582 24.25 20.6645 24.25 15.832C24.25 10.9995 20.3325 7.08203 15.5 7.08203ZM19.4834 12.2568C19.7162 12.0241 20.0924 12.0241 20.3252 12.2568C20.558 12.4896 20.558 12.8659 20.3252 13.0986L14.0107 19.4131C13.778 19.6456 13.4016 19.6458 13.1689 19.4131L10.6748 16.918C10.442 16.6852 10.442 16.3089 10.6748 16.0762C10.9076 15.8436 11.2839 15.8435 11.5166 16.0762L13.5869 18.1475L19.4834 12.2568Z"
                    fill="url(#paint0_linear_9103_17068)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_9103_17068"
                        x1="25.5"
                        y1="15.832"
                        x2="5.97101"
                        y2="12.7992"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop
                            offset="0.0288398"
                            stop-color="var(--gradient-primary-1)"
                        />
                        <stop
                            offset="1"
                            stop-color="var(--gradient-primary-2)"
                        />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    );
};

export default ProductAddedToCartMessage;
